/* ============================================================
   CBDD — LA GALLERIA · motore del tema Shopify
   ============================================================ */
(function () {
  'use strict';

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  /* ---------- immagini rotte: mai icone spezzate ---------- */
  document.addEventListener('error', e => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement)) return;
    const circ = img.closest('.circle-img');
    if (circ) {
      img.remove();
      if (!circ.querySelector('b')) {
        const b = document.createElement('b');
        b.textContent = '◆';
        circ.appendChild(b);
      }
      return;
    }
    img.style.visibility = 'hidden';
  }, true);
  const R = window.CBDD_ROUTES || { root: '/', cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart', predictive: '/search/suggest', search: '/search' };
  const MONEY = window.CBDD_MONEY || '€{{amount_with_comma_separator}}';
  const money = cents => MONEY.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2).replace('.', ','));

  /* ---------- countdown ---------- */
  const promoEl = $('[data-countdown-hours]');
  const hours = promoEl ? parseInt(promoEl.dataset.countdownHours, 10) || 72 : 72;
  let deadline = parseInt(localStorage.getItem('cbdd-deadline') || '0', 10);
  if (!deadline || deadline < Date.now()) {
    deadline = Date.now() + 1000 * 60 * 60 * hours;
    localStorage.setItem('cbdd-deadline', String(deadline));
  }
  const pad = n => String(n).padStart(2, '0');
  function tick() {
    const ms = Math.max(0, deadline - Date.now());
    const d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24,
      m = Math.floor(ms / 60000) % 60, s = Math.floor(ms / 1000) % 60,
      hTot = Math.floor(ms / 3600000);
    $$('[data-timer]').forEach(el => el.textContent = pad(hTot) + 'H : ' + pad(m) + 'M : ' + pad(s) + 'S');
    $$('[data-timer-big]').forEach(big => {
      const set = (k, v) => { const c = $('[data-tb="' + k + '"]', big); if (c) c.textContent = pad(v); };
      set('d', d); set('h', h); set('m', m); set('s', s);
    });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- barra annunci ---------- */
  const abar = $('[data-announcements]');
  let aIdx = 0, aMsgs = [];
  if (abar) {
    aMsgs = $$('[data-announce]', abar).map(el => el.textContent.trim());
    const out = $('[data-announce-out]', abar);
    if (aMsgs.length && out) {
      const show = i => { aIdx = (i + aMsgs.length) % aMsgs.length; out.textContent = aMsgs[aIdx]; };
      show(0);
      setInterval(() => show(aIdx + 1), 6000);
      abar.addEventListener('click', e => {
        const b = e.target.closest('[data-action]');
        if (!b) return;
        if (b.dataset.action === 'abar-prev') show(aIdx - 1);
        if (b.dataset.action === 'abar-next') show(aIdx + 1);
      });
    }
  }

  /* ---------- overlays ---------- */
  function closeAll() {
    ['cartd', 'mmenu', 'chatPop'].forEach(id => { const el = document.getElementById(id); if (el) el.classList.remove('is-open'); });
    $$('.modal').forEach(m => m.classList.remove('is-open'));
    const dim = $('#dim'); if (dim) dim.classList.remove('is-open');
    $$('.search-pop').forEach(p => p.classList.remove('is-open'));
  }
  function openLayer(which) {
    closeAll();
    const dim = $('#dim'); if (dim) dim.classList.add('is-open');
    const map = { cart: 'cartd', menu: 'mmenu', size: 'modalSize', news: 'modalNews' };
    const el = document.getElementById(map[which]);
    if (el) el.classList.add('is-open');
  }

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-on'), 3200);
  }

  /* ---------- carrello (AJAX Shopify) ---------- */
  function updateCount(n) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }
  async function refreshDrawer(open) {
    try {
      const res = await fetch(R.root + '?sections=cart-drawer');
      const data = await res.json();
      const holder = document.getElementById('shopify-section-cart-drawer');
      if (holder && data['cart-drawer']) {
        const wasOpen = open || ($('#cartd') && $('#cartd').classList.contains('is-open'));
        const tpl = document.createElement('template');
        tpl.innerHTML = data['cart-drawer'];
        const fresh = tpl.content.querySelector('#cartd') || tpl.content.firstElementChild;
        const cur = $('#cartd');
        if (cur && fresh) {
          cur.replaceWith(fresh);
          if (wasOpen) { fresh.classList.add('is-open'); const dim = $('#dim'); if (dim) dim.classList.add('is-open'); }
          const n = parseInt(fresh.dataset.count || '0', 10);
          updateCount(n);
        }
      }
    } catch (e) { /* rete assente: lascio lo stato attuale */ }
  }
  async function addToCart(form, goCheckout) {
    const btn = $('[data-add-btn]', form);
    if (btn) btn.classList.add('is-wait');
    try {
      const res = await fetch(R.cart_add + '.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      if (!res.ok) { toast(data.description || 'Questo esemplare non è disponibile.'); return; }
      if (goCheckout) { window.location.href = '/checkout'; return; }
      toast('Aggiunto alla collezione — ' + data.product_title);
      await refreshDrawer(true);
    } catch (e) {
      form.submit(); /* fallback non-AJAX */
    } finally {
      if (btn) btn.classList.remove('is-wait');
    }
  }
  async function changeLine(line, qty) {
    try {
      const res = await fetch(R.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      });
      await res.json();
      if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
      await refreshDrawer(true);
    } catch (e) { window.location.href = R.cart; }
  }

  /* ---------- varianti prodotto ---------- */
  function initVariants(scope) {
    const box = $('[data-variant-box]', scope || document);
    if (!box) return;
    const dataEl = $('[data-variants-json]', box.closest('section, .pdp') || document);
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const optCount = parseInt(box.dataset.optionCount, 10) || 1;
    const state = [];
    for (let i = 1; i <= optCount; i++) {
      const on = $('[data-opt-index="' + i + '"] .is-on', box);
      state.push(on ? on.dataset.optValue : null);
    }
    function apply() {
      const v = variants.find(x => {
        for (let i = 0; i < optCount; i++) {
          if (state[i] && x.options[i] !== state[i]) return false;
        }
        return true;
      });
      if (!v) return;
      const priceEl = $('[data-v-price]'), cmpEl = $('[data-v-compare]'), idEl = $('input[name="id"]'), addBtn = $('[data-add-btn]');
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.style.display = ''; }
        else cmpEl.style.display = 'none';
      }
      if (idEl) idEl.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        const label = addBtn.querySelector('span') || addBtn;
        label.textContent = v.available ? (addBtn.dataset.labelAdd || 'Aggiungi alla collezione') : (addBtn.dataset.labelSoldout || 'Tiratura esaurita');
      }
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    box.addEventListener('click', e => {
      const opt = e.target.closest('[data-opt-value]');
      if (!opt) return;
      const group = opt.closest('[data-opt-index]');
      const idx = parseInt(group.dataset.optIndex, 10) - 1;
      $$('[data-opt-value]', group).forEach(b => b.classList.toggle('is-on', b === opt));
      state[idx] = opt.dataset.optValue;
      apply();
    });
    apply();
  }
  initVariants();

  /* ---------- cornice reale (foto) attorno all'immagine ---------- */
  function applyFrame(value) {
    const af = $('[data-artframe]');
    if (!af) return;
    const v = (value || '').toLowerCase();
    const isBianca = v.indexOf('bianc') > -1;
    const isNoce = v.indexOf('noce') > -1 || v.indexOf('legno') > -1;
    const isStampa = v.indexOf('stampa') > -1;
    const cls = isBianca ? 'frame--bianca' : (isNoce ? 'frame--noce' : (isStampa ? 'frame--stampa' : 'frame--nera'));
    af.classList.remove('frame--nera', 'frame--bianca', 'frame--noce', 'frame--stampa');
    af.classList.add(cls);
    // scambia la foto della cornice
    const frameImg = $('[data-frame-img]', af);
    const stage = af.closest('[data-frame-stage]');
    if (frameImg && stage && !isStampa) {
      const src = isBianca ? stage.dataset.frameBianca : (isNoce ? stage.dataset.frameNoce : stage.dataset.frameNera);
      if (src && frameImg.getAttribute('src') !== src) frameImg.src = src;
    }
  }
  document.addEventListener('click', e => {
    const fc = e.target.closest('.frame-cards [data-opt-value]');
    if (fc) applyFrame(fc.dataset.optValue);
  });
  (function () {
    const sel = $('.frame-cards .frame-card.is-on') || $('.frame-cards [data-opt-value]');
    if (sel) applyFrame(sel.dataset.optValue);
  })();

  /* ---------- galleria prodotto ---------- */
  document.addEventListener('click', e => {
    const th = e.target.closest('[data-gt]');
    if (!th) return;
    const wrap = th.closest('[data-gallery]');
    if (!wrap) return;
    $$('[data-gt]', wrap).forEach(t => t.classList.toggle('is-on', t === th));
    $$('[data-gv]', wrap).forEach(v => v.classList.toggle('is-on', v.dataset.gv === th.dataset.gt));
  });

  /* ---------- zoom inline immagine prodotto ---------- */
  (function () {
    const ZOOM = 1.7; // fattore di ingrandimento (moderato)
    $$('[data-zoom]').forEach(scene => {
      const src = scene.dataset.zoomSrc;
      if (!src) return;
      let layer = null;

      function ensureLayer() {
        if (layer) return layer;
        layer = document.createElement('div');
        layer.className = 'zoom-layer';
        layer.style.backgroundImage = 'url("' + src + '")';
        layer.style.backgroundSize = (ZOOM * 100) + '%';
        scene.appendChild(layer);
        return layer;
      }
      function moveTo(e) {
        const r = scene.getBoundingClientRect();
        const px = ((e.clientX - r.left) / r.width) * 100;
        const py = ((e.clientY - r.top) / r.height) * 100;
        layer.style.backgroundPosition = Math.max(0, Math.min(100, px)) + '% ' + Math.max(0, Math.min(100, py)) + '%';
      }
      function enable(e) {
        ensureLayer();
        scene.classList.add('zoom-active');
        moveTo(e);
      }
      function disable() {
        scene.classList.remove('zoom-active');
      }

      scene.addEventListener('click', e => {
        if (scene.classList.contains('zoom-active')) disable();
        else enable(e);
      });
      scene.addEventListener('mousemove', e => {
        if (scene.classList.contains('zoom-active')) moveTo(e);
      });
      scene.addEventListener('mouseleave', disable);
      // touch: trascina il dito per spostare il dettaglio
      scene.addEventListener('touchmove', e => {
        if (!scene.classList.contains('zoom-active')) return;
        e.preventDefault();
        moveTo(e.touches[0]);
      }, { passive: false });
    });
  })();

  /* ---------- ricerca predittiva ---------- */
  function bindSearch(input, pop) {
    if (!input || !pop) return;
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (!q) { pop.classList.remove('is-open'); return; }
      t = setTimeout(async () => {
        try {
          const url = R.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,collection&resources[limit]=6';
          const res = await fetch(url);
          const data = await res.json();
          const prods = (data.resources.results.products || []);
          const pages = (data.resources.results.pages || []);
          const colls = (data.resources.results.collections || []);
          let html = prods.map(p =>
            '<a class="sp-row" href="' + p.url + '">' +
            '<span class="sp-thumb">' + (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=90" alt="">' : '<b>◆</b>') + '</span>' +
            '<span><span class="t">' + p.title + '</span><br><span class="s">Quadro in galleria</span></span>' +
            '<span class="p">' + (p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></a>'
          ).join('');
          html += colls.map(c => '<a class="sp-row" href="' + c.url + '"><span class="sp-thumb"><b>XV</b></span><span><span class="t">' + c.title + '</span><br><span class="s">Collezione</span></span></a>').join('');
          html += pages.map(p => '<a class="sp-row" href="' + p.url + '"><span class="sp-thumb"><b>→</b></span><span><span class="t">' + p.title + '</span><br><span class="s">Pagina</span></span></a>').join('');
          if (!html) html = '<p class="sp-empty">Nessun mito con questo nome — per ora. Proponilo per il Quadro XV.</p>';
          pop.innerHTML = html;
          pop.classList.add('is-open');
        } catch (e) { /* silenzioso */ }
      }, 220);
    });
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        window.location.href = R.search + '?q=' + encodeURIComponent(input.value.trim());
      }
    });
  }
  bindSearch($('#searchInput'), $('#searchPop'));
  bindSearch($('#searchInputM'), $('#searchPopM'));

  /* ---------- rails ---------- */
  $$('[data-rail]').forEach(rail => {
    const wrap = rail.closest('.rail-wrap');
    if (!wrap) return;
    const bar = wrap.querySelector('.rail-progress i');
    const update = () => {
      if (!bar) return;
      const max = rail.scrollWidth - rail.clientWidth;
      const frac = rail.clientWidth / rail.scrollWidth;
      bar.style.width = Math.max(8, frac * 100) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * (100 / frac - 100) : 0) + '%)';
    };
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 120);
  });
  function railStep(rail, dir) {
    const card = rail.querySelector('.card');
    const w = card ? card.getBoundingClientRect().width + 20 : 320;
    rail.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
  }

  /* ---------- tabs "in evidenza" (home) ---------- */
  $$('[data-feat-root]').forEach(root => {
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-feat]');
      if (!b) return;
      const key = b.dataset.feat;
      $$('[data-feat]', root).forEach(x => x.classList.toggle('is-on', x.dataset.feat === key));
      const art = $('[data-feat-art]', root);
      const src = b.dataset.featImg;
      if (art && src) { art.style.opacity = 0; setTimeout(() => { art.src = src; art.style.opacity = 1; }, 180); }
      const desc = $('[data-feat-desc]', root);
      if (desc && b.dataset.featDesc) desc.textContent = b.dataset.featDesc;
      const cta = $('[data-feat-cta]', root);
      if (cta && b.dataset.featUrl) cta.setAttribute('href', b.dataset.featUrl);
    });
  });

  /* ---------- tabs cura ---------- */
  document.addEventListener('click', e => {
    const tab = e.target.closest('[data-care]');
    if (!tab) return;
    const root = tab.closest('section') || document;
    $$('[data-care]', root).forEach(t => t.classList.toggle('is-on', t === tab));
    $$('[data-care-panel]', root).forEach(p => p.classList.toggle('is-on', p.dataset.carePanel === tab.dataset.care));
  });

  /* ---------- fascia citazioni ---------- */
  $$('[data-quoteband]').forEach(band => {
    const items = $$('.qb-item', band);
    const dots = $$('[data-qb]', band);
    if (items.length < 2) return;
    let idx = 0;
    const show = i => {
      idx = (i + items.length) % items.length;
      items.forEach((el, k) => el.classList.toggle('is-on', k === idx));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === idx));
    };
    let timer = setInterval(() => show(idx + 1), 6500);
    band.addEventListener('click', e => {
      const d = e.target.closest('[data-qb]');
      if (!d) return;
      clearInterval(timer);
      show(parseInt(d.dataset.qb, 10));
    });
  });

  /* ---------- filtri collezione ---------- */
  const collGrid = $('[data-coll-grid]');
  if (collGrid) {
    const applyFilter = f => {
      $$('[data-filter]').forEach(c => c.classList.toggle('is-on', c.dataset.filter === f));
      $$('[data-kind]', collGrid).forEach(card => {
        card.style.display = (f === 'tutti' || card.dataset.kind === f) ? '' : 'none';
      });
    };
    document.addEventListener('click', e => {
      const chip = e.target.closest('[data-filter]');
      if (chip) applyFilter(chip.dataset.filter);
    });
    const params = new URLSearchParams(window.location.search);
    if (params.get('f')) applyFilter(params.get('f'));
  }

  /* ---------- delega click globale ---------- */
  document.addEventListener('click', e => {
    const el = e.target.closest('[data-action]');
    if (!el) {
      if (!e.target.closest('.search')) $$('.search-pop').forEach(p => p.classList.remove('is-open'));
      if (!e.target.closest('#chatPop') && !e.target.closest('.fab-chat')) { const c = $('#chatPop'); if (c) c.classList.remove('is-open'); }
      return;
    }
    const a = el.dataset.action;
    if (a === 'cart-open') { e.preventDefault(); openLayer('cart'); }
    else if (a === 'menu-open') openLayer('menu');
    else if (a === 'modal-size') openLayer('size');
    else if (a === 'modal-news') { if (!e.target.closest('.x')) openLayer('news'); }
    else if (a === 'fab-close') { e.stopPropagation(); const f = $('#fabTab'); if (f) f.style.display = 'none'; }
    else if (a === 'close-all') closeAll();
    else if (a === 'chat-toggle') { const c = $('#chatPop'); if (c) c.classList.toggle('is-open'); }
    else if (a === 'qty-plus' || a === 'qty-minus') {
      const line = parseInt(el.dataset.line, 10);
      const qty = parseInt(el.dataset.qty, 10) + (a === 'qty-plus' ? 1 : -1);
      changeLine(line, Math.max(0, qty));
    }
    else if (a === 'line-remove') changeLine(parseInt(el.dataset.line, 10), 0);
    else if (a === 'rev-more') { $$('.rev-item.is-hidden').forEach(r => r.classList.remove('is-hidden')); el.style.display = 'none'; }
    else if (a === 'rail-prev' || a === 'rail-next') {
      const rail = el.closest('.rail-wrap').querySelector('[data-rail]');
      if (rail) railStep(rail, a === 'rail-next' ? 1 : -1);
    }
    else if (a === 'search-go') {
      const inp = $('#searchInput') || $('#searchInputM');
      if (inp && inp.value.trim()) window.location.href = R.search + '?q=' + encodeURIComponent(inp.value.trim());
    }
  });

  /* ---------- form prodotto AJAX ---------- */
  document.addEventListener('submit', e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, false);
  });
  document.addEventListener('click', e => {
    const buy = e.target.closest('[data-buy-now]');
    if (!buy) return;
    e.preventDefault();
    const form = buy.closest('form[data-product-form]') || $('form[data-product-form]');
    if (form) addToCart(form, true);
  });

  /* ---------- esc ---------- */
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
})();
